import axios from '../axios'

/*
 * 數據模塊
 */
// 获取验证码
// export const getCaptcha = (data) => {
// 	return axios({
// 		url: '/captcha',
// 		method: 'get',
// 		params:data
// 	})
// };

// 登录
export const login = (data) => {
    return axios({
		url: '/api/sys/login',
		method: 'post',
		data: data
    })
};

// 登出
export const loginout = (data) => {
	return axios({
	  url: '/api/sys/logout',
	  method: 'post',
	  data: data
	})
};


// WEBPACK FOOTER //
// ./src/http/moudules/login.js